export default __webpack_public_path__ + "static/media/hand-apple.52b84c3b.webp";